// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2g-PH","text":"SelectPayment_text__1MMO0","title":"SelectPayment_title__1-4M-","btn":"SelectPayment_btn__1u3Nd"};